"use strict";

var _interopRequireWildcard = require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
var _interopRequireDefault = require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
var _regeneratorRuntime2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/createClass.js"));
var _callSuper2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/inherits.js"));
var _defineProperty2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _importProduct = require("@/api/importProduct");
var _moment = _interopRequireDefault(require("moment"));
var _vuePropertyDecorator = require("vue-property-decorator");
var _ImportModal = _interopRequireWildcard(require("../import/components/ImportModal.vue"));
var _ImportModal2 = _interopRequireDefault(require("./components/ImportModal.vue"));
var _ListImportWarehouseModal = _interopRequireDefault(require("./components/ListImportWarehouseModal.vue"));
var POTable = /*#__PURE__*/function (_Vue) {
  function POTable() {
    var _this;
    (0, _classCallCheck2.default)(this, POTable);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = (0, _callSuper2.default)(this, POTable, [].concat(args));
    (0, _defineProperty2.default)(_this, "data", void 0);
    (0, _defineProperty2.default)(_this, "total", void 0);
    (0, _defineProperty2.default)(_this, "query", void 0);
    (0, _defineProperty2.default)(_this, "loading", void 0);
    (0, _defineProperty2.default)(_this, "$refs", void 0);
    (0, _defineProperty2.default)(_this, "ImportProductStatus", _ImportModal.ImportProductStatus);
    return _this;
  }
  (0, _inherits2.default)(POTable, _Vue);
  return (0, _createClass2.default)(POTable, [{
    key: "formatDate",
    value: function formatDate(date) {
      return (0, _moment.default)(date).format("DD/MM/YYYY");
    }
  }, {
    key: "handleAddImportInvoice",
    value: function handleAddImportInvoice(row) {
      this.$refs.importPOModal.handleCreate(row);
    }
  }, {
    key: "handleDelete",
    value: function handleDelete(row) {
      var _this2 = this;
      this.$confirm("Bạn chắc chắn muốn xóa po này?", "Cảnh báo", {
        confirmButtonText: "Xóa",
        cancelButtonText: "Không",
        type: "warning"
      }).then(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _importProduct.importProductApi.remove(row.id).then(function () {
                return _this2.$emit("fetchData");
              });
              _this2.$notify({
                title: "Xoá PO",
                message: "Successfully",
                type: "success"
              });
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      })));
    }
  }, {
    key: "handleEdit",
    value: function handleEdit(row) {
      this.$refs.importModal.handleUpdate(row);
    }
  }, {
    key: "handleViewList",
    value: function handleViewList(row) {
      this.$refs.list.handleView(row);
    }
  }]);
}(_vuePropertyDecorator.Vue);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], POTable.prototype, "data", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  default: 0
})], POTable.prototype, "total", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], POTable.prototype, "query", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  default: false
})], POTable.prototype, "loading", void 0);
POTable = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  components: {
    ImportPOModal: _ImportModal2.default,
    ImportModal: _ImportModal.default,
    ListImportWarehouseModal: _ListImportWarehouseModal.default
  }
})], POTable);
var _default = exports.default = POTable;